
define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var Dialog = require("ui/dialog/Dialog");
    var ConnectorModel = require("manager-models/data-sources/conversation-sources/ConnectorModel");
    var ConnectorUpdateFieldModel = require("manager-models/data-sources/conversation-sources/ConnectorUpdateFieldModel");
    var FacebookExtendAccessTokenModel = require("manager-models/data-sources/conversation-sources/types/FacebookExtendAccessTokenModel");
    var FacebookActivationView = require("manager-views/data-sources/conversation-sources/facebook/FacebookActivationView");
    var FacebookConfigView = require("manager-views/data-sources/conversation-sources/facebook/FacebookConfigView");
    var FacebookPagesDialogView = require("manager-views/data-sources/conversation-sources/facebook/FacebookPagesDialogView");
    var LEConfig = require("assets/config/le-env-conf");
    var SettingsCollection = require("collections/SettingsCollection");
    var ProfileModel = require("models/entities/ProfileModel");

    // FB SDK is loaded to the window (window.FB)
    require("facebook");

    var FACEBOOK_ACTIVATION_PATH = "data/sources/facebook/activation";
    var FACEBOOK_CONFIG_PATH = "data/sources/facebook/config";
    var CONNECTED = 'connected';

    var FacebookController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        FacebookController = Marionette.Controller.extend({

            isEnabled: false,

            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function() {
                return this._getMainView();
            },
            showActivationView: function() {
                this._showActivationView();
            },
            showConfigView: function() {
                this._showConfigView();
            },

            _initialize:function () {
                LEManager.logger.debug("FacebookController:initialize");
                this.channel = LEManager.media.channel("conversationSources");
                LE.checkFBLoginState = _.bind(this._checkFBLoginState, this);
                LE.initFacebook = _.bind(this._initFacebook, this);
                this._bindEvents();
            },

            _bindEvents: function(){
                LEManager.logger.debug("call of _bindEvents","FacebookController:_bindEvents");
                this.listenTo(this.channel, "facebook:activation:cancel", this._onActivationCancelClick);
                this.listenTo(this.channel, "facebook:activation:next", this._onActivationNextClick);
                this.listenTo(this.channel, "facebook:config:cancel", this._onConfigCancelClick);
                this.listenTo(this.channel, "facebook:config:back", this._onConfigBackClick);
                this.listenTo(this.channel, "facebook:config:done", this._onConfigDoneClick);
                this.listenTo(this.channel, "facebook:config:dialog",this._openFacebookPagesDialog);
                this.listenTo(this.channel, "facebook:subscribe:page", this._facebookSubscribePage);
                this.listenTo(this.channel, "facebook:unsubscribe:page", this._facebookUnsubscribePage);
                this.listenTo(this.channel, "facebook:external:user:changed", this._facebookExternalUserChanged);
                this.listenTo(this.channel, "facebook:config:dialog:close", this._onCloseDialog);
            },

            _getMainView: function() {
                LEManager.logger.debug("FacebookController:getMainView - started");
                this._initPageComponent();
                return this.pageView;
            },

            _initPageComponent: function(){
                LEManager.logger.debug ("FacebookController:_initPageComponent");

                this.pageView = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    hasActionStrip: false
                });

                /* fired when the inside page view is being closed.
                 * do not move this to _bindEvents as this should be called everytime _initPageComponent is called (when pageView is closed) */
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _onPageClose: function(closedPageView) {
                LEManager.logger.debug("Page component in facebook is closed. re-init it.", "FacebookController:_onPageClose");
                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.pageView && closedPageView && closedPageView.cid === this.pageView.cid) {
                    this.pageView = null;
                    this.insideView = null;
                }
            },

            _initData: function() {
                this.connectorsCollection = LEManager.getModuleDataManager().getConnectorsCollection();
                this.connectorModels = this.connectorsCollection.getConnectorsByType(this.connectorsCollection.SOURCE_TYPES.FACEBOOK);
                this.configurationType = this.connectorsCollection.getConnectorConfigurationByType(this.connectorsCollection.SOURCE_TYPES.FACEBOOK);
            },

            _fetchConnectorsCollection: function(options) {
                var fetchOptions = $.extend({
                    fetchOptions: {
                        urlParameters: this.connectorsCollection.URL_PARAMETERS.CONFIG
                    }
                }, options);
                this.connectorsCollection.fetch(fetchOptions);
            },

            _onConnectorsCollectionSuccess: function(collection, response, options) {
                LEManager.logger.debug("get connectors collection is successful","FacebookController:_onConnectorsCollectionSuccess");
                this.connectorModels = this.connectorsCollection.getConnectorsByType(this.connectorsCollection.SOURCE_TYPES.FACEBOOK);
                this.facebookPagesDialogView.refreshData({connectorModels: this.connectorModels});
                LEManager.closeLoader();
            },

            _onConnectorsCollectionError: function(collection, response, options) {
                LEManager.logger.error("get connectors collection error. - FacebookController:_onConnectorsCollectionError", collection);
                this._showErrorMessage();
                LEManager.closeLoader();
            },

            _createEmptyFacebookModel: function(isEnabled) {
                var model = new ConnectorModel({
                    name: LE.translator.translate("LEManager.dataSources.conversationSources.gallery." + this.configurationType.key + ".name"),
                    type: this.connectorsCollection.SOURCE_TYPES.FACEBOOK
                });
                model.setEnabled(isEnabled);
                return model;
            },

            _showActivationView: function() {
                LEManager.logger.debug("call of show Activation","FacebookController:_showActivationView");
                this.pageView.setTitle(LE.translator.translate("LEManager.dataSources.conversationSources.facebook.title"));
                this._initData();
                if(!_.isEmpty(this.connectorModels)) {
                    this.isEnabled = this.connectorModels[0].getEnabled();
                } else {
                    this.isEnabled = false;
                }
                this.connectorModel = this._createEmptyFacebookModel(this.isEnabled);
                this.insideView = new FacebookActivationView({model: this.connectorModel});
                this.pageView.setInsideView(this.insideView);
            },

            _showConfigView: function() {
                LEManager.logger.debug("call of show Configuration","FacebookController:_showActivateView");
                this.pageView.setTitle(LE.translator.translate("LEManager.dataSources.conversationSources.facebook.configuration.title"));
                this._initData();
                var agentManagers = this._getAgentManagers();
                var siteSettingsAgentManagerCollection = LEManager.getModuleDataManager().getSiteSettingsAgentManagerCollection();
                this.agentManagerModel = siteSettingsAgentManagerCollection.get(SettingsCollection.SETTINGS_ENUM.SETTING_ID.MSGGW_AGENT_MANAGER_PID);
                this.insideView = new FacebookConfigView({connectorModels: this.connectorModels, agentManagers: agentManagers, agentManagerModel: this.agentManagerModel});
                this.pageView.setInsideView(this.insideView);
            },

            _getAgentManagers: function() {
                var profilesCollection = LEManager.getModuleDataManager().getProfilesCollection();
                var agentManagerProfiles = profilesCollection.where({roleTypeId: parseInt(ProfileModel.ROLES.AGENT_MANAGER, 10)});
                var agentManagers = [];
                if(agentManagerProfiles) {
                    var usersCollection = LEManager.getModuleDataManager().getUsersCollection();
                    usersCollection.each(function(user) {
                        var profiles = user.getProfiles();
                        if(profiles) {
                            _.some(agentManagerProfiles, function(agentManagerProfile) {
                                if(profiles.indexOf(agentManagerProfile.id) > -1) {
                                    var userObj = {
                                        id: user.getPid(),
                                        value: user.getDisplayName(),
                                        subText: user.getLoginName()
                                    };
                                    agentManagers.push(userObj);
                                    return true;
                                }
                            }, this);
                        }
                    }, this);
                }
                return agentManagers;
            },

            _facebookExternalUserChanged: function(externalUserId) {
                this.externalUserId = externalUserId;
            },

            _openFacebookPagesDialog: function() {
                LEManager.logger.debug("Initiating and openning the subscribe facebook pages dialog ", "FacebookController:_openFacebookPagesDialog");
                this.facebookPagesDialogView = new FacebookPagesDialogView({facebookPages: this.facebookPages, connectorModels: this.connectorModels});
                this.dialog = new Dialog({
                    innerView: this.facebookPagesDialogView,
                    permutation: Dialog.PERMUTATION.C,
                    moduleName:LEManager.moduleName,
                    context:LE.context
                });
                if(this.insideView.showDialog) {
                    this.insideView.showDialog(this.dialog);
                }
                this.listenTo(this.facebookPagesDialogView, "dialogInnerView:closeDialog", this._closeFacebookDialog);
            },

            _closeFacebookDialog: function() {
                LEManager.logger.debug("Closing the subscribe facebook dialog and refresh data", "FacebookController:_closeFacebookDialog");
                this._onCloseDialog();
                this._refreshSubscribedList();
            },

            _onCloseDialog: function() {
                LEManager.logger.debug("Closing dialog", "FacebookController:_onCloseDialog");
                if(this.facebookPagesDialogView) {
                    this.stopListening(this.facebookPagesDialogView);
                }
                if(this.insideView && this.insideView.isDialogOpen()) {
                    this.insideView.closeDialog();
                }
                this.facebookPagesDialogView = null;
                if(this.dialog) {
                    this.dialog.close();
                    this.dialog = null;
                }
            },

            _refreshSubscribedList: function() {
                var options = {
                    success: _.bind(this._onConnectorsCollectionConfigurationSuccess, this),
                    error: _.bind(this._onConnectorsCollectionConfigurationError, this)
                };
                this._fetchConnectorsCollection(options);
            },

            _onConnectorsCollectionConfigurationSuccess: function() {
                LEManager.logger.debug("get connectors collection success","FacebookController:_onConnectorsCollectionConfigurationSuccess");
                this.insideView.refreshSubscribedPagesNames({connectorModels: this.connectorModels});
                LEManager.closeLoader();
            },

            _onConnectorsCollectionConfigurationError: function() {
                LEManager.logger.debug("get connectors collection failed","FacebookController:_onConnectorsCollectionConfigurationError");
                this._showFacebookError();
            },

            _facebookSubscribePage: function(facebookPageData) {
                LEManager.logger.debug("subscribe page","FacebookController:_facebookSubscribePage");
                LEManager.showLoader();
                this.facebookPageData = facebookPageData || {};
                var accessToken = this._getAccessTokenByPageId(this.facebookPageData.pageId);
                if(accessToken) {
                    FB.api('/' + this.facebookPageData.pageId + '/subscribed_apps', 'post', {access_token: accessToken}, _.bind(this._saveConnector, this));
                } else {
                    LEManager.logger.error("access token not exists for this page. - FacebookController:_facebookSubscribePage");
                    this._showErrorMessage();
                    LEManager.closeLoader();
                }
            },

            _saveConnector: function(response) {
                if(response && response.success) {
                    this.connectorModel = this._getConnectorModelById(this.facebookPageData.pageId);
                    if(!this.connectorModel) {
                        this.connectorModel = this._createEmptyFacebookModel(this.isEnabled);
                        var configurationModel = this.connectorModel.getConfigurationModel();
                        configurationModel.setPageId(this.facebookPageData.pageId);
                        configurationModel.setAccessToken(this.facebookPageData.accessToken);
                        configurationModel.set("name", this.facebookPageData.pageName);//TODO ivanm check this parameter
                        if(this.isEnabled) {
                            configurationModel.set("enabled", this.isEnabled);
                        }
                        this.connectorModel.set("name",this.facebookPageData.pageName);
                        this.connectorModel.save(null, {
                            urlParameters: this.connectorsCollection.URL_PARAMETERS.CONFIG,
                            success: _.bind(this._onRefreshDialogAfterSuccess, this),
                            error: _.bind(this._onFacebookSubscribePageError, this)
                        });
                    } else {
                        LEManager.logger.error("connector model not exists. - FacebookController:_facebookSubscribePage");
                        this._showErrorMessage();
                        LEManager.closeLoader();
                    }
                } else {
                    LEManager.logger.error("subscribe page in facebook failed. - FacebookController:_facebookSubscribePage");
                    this._showErrorMessage();
                    LEManager.closeLoader();
                }
            },

            _onFacebookSubscribePageError: function(model, response, options) {
                LEManager.logger.error("save connector model error. - FacebookController:_onFacebookSubscribePageError", model);
                this._showErrorMessage();
                LEManager.closeLoader();
            },

            _facebookUnsubscribePage: function(facebookPageData) {
                LEManager.logger.debug("unsubscribe page","FacebookController:_facebookUnsubscribePage");
                this.facebookPageData = facebookPageData || {};
                var deleteModel = this._getConnectorModelById(this.facebookPageData.pageId);
                if(deleteModel) {
                    deleteModel.destroy({
                        urlParameters: this.connectorsCollection.URL_PARAMETERS.CONFIG,
                        success: _.bind(this._onRefreshDialogAfterSuccess, this),
                        error: _.bind(this._onUnsubscribeError, this)
                    });
                } else {
                    this._showErrorMessage();
                }
            },

            _onRefreshDialogAfterSuccess: function() {
                var options = {
                    success: _.bind(this._onConnectorsCollectionSuccess, this),
                    error: _.bind(this._onConnectorsCollectionError, this)
                };
                this._fetchConnectorsCollection(options);
            },

            _onUnsubscribeError: function(){
                this._showErrorMessage();
            },

            _getAccessTokenByPageId: function(pageId) {
                var facebookPage = _.find(this.facebookPages, function(facebookPage){
                    if(facebookPage.id === pageId) {
                        return facebookPage;
                    }
                }, this);
                return facebookPage ? facebookPage.access_token : facebookPage;
            },

            _getConnectorModelById: function(pageId) {
                var connectorModel = _.find(this.connectorModels, function(model){
                    if(model.get("configuration") && model.get("configuration.pageId") === pageId) {
                        return model;
                    }
                }, this);
                return connectorModel;
            },

            _onActivationCancelClick: function(){
                LEManager.router.navigateBack();
            },

            _onActivationNextClick: function(){
                LEManager.logger.debug("call of _onActivationNextClick","FacebookController:_onActivationNextClick");
                var changedAttributesKeys = _.keys(this.connectorModel.changedAttributes());
                this.isEnabled = this.connectorModel.getEnabled();
                if (!_.isEmpty(changedAttributesKeys) && !_.isEmpty(this.connectorModels)){
                    LEManager.showLoader();
                    var connectorUpdateFieldModel = new ConnectorUpdateFieldModel({
                        name: "enabled",
                        value: this.isEnabled,
                        type: ConnectorModel.SOURCE_TYPES.FACEBOOK
                    });
                    connectorUpdateFieldModel.save(null, {
                        success: _.bind(this._onActivationSaveSuccess, this),
                        error: _.bind(this._onActivationSaveError, this)
                    });
                } else {
                    LEManager.router.navigateNonBackable(FACEBOOK_CONFIG_PATH);
                }
            },

            _onActivationSaveSuccess: function(model, response, options) {
                LEManager.logger.debug("connectorModel.save is successful","FacebookController:_onActivationSaveSuccess");
                LEManager.closeLoader();
                LEManager.router.navigateNonBackable(FACEBOOK_CONFIG_PATH);
            },

            _onActivationSaveError: function(model, response, options) {
                LEManager.logger.error("save connector model error. - FacebookController:_onActivationSaveError", model);
                LEManager.closeLoader();
                LEManager.notifier.showError(LE.translator.translate("LEManager.dataSources.conversationSources.general.activation.save.error"));
            },

            _showErrorMessage: function() {
                var facebookSubscribePagesCollection = this.facebookPagesDialogView.getFacebookPagesCollection();
                var facebookPagesView = this.facebookPagesDialogView.getFacebookPagesView();
                if(facebookSubscribePagesCollection) {
                    _.some(facebookSubscribePagesCollection.models, function(model) {
                        if(model.id === this.facebookPageData.pageId) {
                            var itemView = facebookPagesView.children.findByModel(model);
                            itemView.setError();
                            return true;
                        }
                    }, this);
                }
            },

            _onConfigBackClick: function(){
                LEManager.logger.debug("call of _onConfigBackClick","FacebookController:_onConfigBackClick");
                LEManager.router.navigateNonBackable(FACEBOOK_ACTIVATION_PATH);
            },

            _onConfigCancelClick: function(){
                LEManager.logger.debug("close the page","FacebookController:_onConfigCancelClick");
                LEManager.router.navigateBack();
            },

            _onConfigDoneClick: function(){
                LEManager.logger.debug("save external user","FacebookController:_onConfigDoneClick");
                if(!_.isNull(this.externalUserId) && !_.isUndefined(this.externalUserId)) {
                    var options = {
                        success: _.bind(this._onAgentManagerSuccess, this),
                        error: _.bind(this._onAgentManagerError, this)
                    };
                    this.agentManagerModel.setValue(this.externalUserId);
                    this.agentManagerModel.save(null, options);
                } else {
                    this._onAgentManagerSuccess();
                }
            },

            _onAgentManagerSuccess: function() {
                LEManager.logger.debug("close the page","FacebookController:_onAgentManagerSuccess");
                LEManager.closeLoader();
                LEManager.router.navigateBack();
            },

            _onAgentManagerError: function() {
                LEManager.logger.error("save external user failed","FacebookController:_onAgentManagerError");
                LEManager.closeLoader();
                this._showFacebookError();
            },

            _showFacebookError: function() {
                LEManager.notifier.showError(LE.translator.translate("LEManager.dataSources.conversationSources.facebook.error.connect.facebook"));
            },

            _initFacebook: function() {
                FB.init({
                    appId      : LEConfig.facebookConfiguration.appId,
                    status     : true,
                    cookie     : true,
                    xfbml      : true,
                    version    : 'v3.0'
                });
            },

            _checkFBLoginState: function() {
                FB.getLoginStatus(_.bind(function(response) {
                    if (response.status === CONNECTED) {
                        this._fetchFacebookDataAccount(response);
                    } else if (this.dialog) {
                        this._closeFacebookDialog();
                    }
                }, this));
            },

            _fetchFacebookDataAccount: function(response) {
                if(response && response.authResponse && response.authResponse.accessToken) {
                    var facebookExtendAccessTokenModel = new FacebookExtendAccessTokenModel();
                    facebookExtendAccessTokenModel.fetch({
                        data: { token: response.authResponse.accessToken },
                        success: _.bind(function () {
                            LEManager.logger.debug("Success fetching the extended token", "FacebookController:_fetchFacebookDataAccount");
                            FB.api('/me/accounts', 'get', {access_token: facebookExtendAccessTokenModel.getAccessToken()}, _.bind(this._getFacebookAccountDataCallback, this));
                        },this),
                        error: _.bind(function () {
                            LEManager.logger.error("error fetching the extended token", "FacebookController:_fetchFacebookDataAccount");
                            this._showFacebookError();
                        },this)
                    });

                } else {
                    this._showFacebookError();
                }
            },

            _getFacebookAccountDataCallback: function(response) {
                if(response && response.data) {
                    this.facebookPages = response.data;
                    if(!this.dialog) {
                        this._openFacebookPagesDialog();
                    }
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return FacebookController;
});
